import React, { ReactNode } from 'react';
import { red } from '@mui/material/colors';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { BpfLinkType } from '@trnsact/trnsact-shared-types';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { calcFieldsAmount } from '../../../lib';
import { StageAttributes } from '../StageAttributes';
import { Stage, UpdateStageFields } from '../../../api';

interface Props {
  stage: Stage;
  parentId: string;
  isLoading: boolean;
  closeSlot: ReactNode;
  parentType: BpfLinkType;
  onUpdateStageAttributes: (dto: UpdateStageFields) => Promise<void>;
}

export const StageAttributesContainer = ({
  stage,
  parentId,
  closeSlot,
  isLoading,
  parentType,
  onUpdateStageAttributes,
}: Props) => {
  const classes = useStyles();

  const stageFields = stage.fieldValues?.values?.length ? stage.fieldValues.values : stage.stageFields;
  const { totalFields, requiredFields, requiredCompletedFields, totalCompletedFields } = calcFieldsAmount(stageFields);

  const totalInfo = `${totalCompletedFields}/${totalFields} Total`;
  const requiredInfo = `${requiredCompletedFields}/${requiredFields} Required`;

  return (
    <Box>
      <Box className={classes.attributesHeader}>
        <Typography variant="subtitle2" component="span">
          Stage Attributes
        </Typography>

        <Box className={classes.attributesCounter}>
          <RenderWithCondition condition={!!requiredFields}>
            <Box className={classes.attributesRequired}>
              <Typography color="error" variant="body2">
                {requiredInfo}
              </Typography>
            </Box>
          </RenderWithCondition>

          <Box className={classes.attributesTotal}>
            <Typography variant="body2">{totalInfo}</Typography>
          </Box>
        </Box>
      </Box>

      <StageAttributes
        stage={stage}
        parentId={parentId}
        isLoading={isLoading}
        parentType={parentType}
        onUpdateStageAttributes={onUpdateStageAttributes}
      />

      {closeSlot}
    </Box>
  );
};

const useStyles = makeStyles({
  attributesHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  attributesCounter: {
    gap: '0.25rem',
    display: 'flex',
    alignItems: 'center',
  },
  attributesRequired: {
    cursor: 'default',
    background: red[50],
    borderRadius: '1rem',
    padding: '0.2rem 0.5rem',
    border: `1px solid ${red[100]}`,
  },
  attributesTotal: {
    gap: '0.25rem',
    alignItems: 'center',
  },
});
